export default class ListEntityWorkTypeAssociationsByEntityIdError extends Error {

}